import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const GroupCartBottomSheetContainer = styled.div(({ theme }) => ({
    padding: `${theme.spacing.xSmall} 0`,
    paddingBottom: `calc(var(--sab, 0px) + ${theme.spacing.xSmall})`,
}));

export const TitleText = styled(Text)(({ theme }) => ({
    marginBottom: theme.spacing.xSmall,
    marginRight: theme.spacing.large,
}));

export const SubtitleText = styled(Text)(({ theme }) => ({
    marginBottom: theme.spacing.xxLarge,
}));
